export default [
    {
        path: '/error-404',
        name: 'error-404',
        component: () => import('@/views/error/Error404.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            action: 'read',
        },
    },
    {
        path: '/datafast-callback',
        name: 'datafast-callback',
        component: () => import('@/views/pages/DataFastCallback.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            action: 'read',
        },
    },
    {
        path: '/login',
        name: 'auth-login',
        component: () => import('@/views/pages/authentication/Login.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/pages/miscellaneous/coming-soon',
        name: 'misc-coming-soon',
        component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
        meta: {
            layout: 'full',
        },
    },
    {
        path: '/no-autorizado',
        name: 'misc-not-authorized',
        component: () =>
            import('@/views/pages/miscellaneous/NotAuthorized.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
        },
    },
    {
        path: '/pages/miscellaneous/under-maintenance',
        name: 'misc-under-maintenance',
        component: () =>
            import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
        meta: {
            layout: 'full',
        },
    },
    {
        path: '/pages/miscellaneous/error',
        name: 'misc-error',
        component: () => import('@/views/pages/miscellaneous/Error.vue'),
        meta: {
            layout: 'full',
        },
    },
    {
        path: '/perfil/:option',
        name: 'perfil',
        component: () =>
            import('@/views/pages/account-setting/AccountSetting.vue'),
        meta: {
            pageTitle: 'Perfil',
            breadcrumb: [
                {
                    text: 'Usuarios',
                },
            ],
            resource: 'Profile',
            action: 'read',
        },
    },
    {
        path: '/suscripcion',
        name: 'suscripcion',
        component: () => import('@/views/pages/suscripcion/Suscripcion.vue'),
        meta: {
            pageTitle: 'Suscripción',
            breadcrumb: [
                {
                    text: 'Suscripción',
                },
            ],
            resource: 'PortalClient',
            action: 'read',
        },
    },
    {
        path: '/pagos',
        name: 'pagos',
        component: () => import('@/views/pages/pagos/Pagos.vue'),
        meta: {
            pageTitle: 'Pagos',
            breadcrumb: [
                {
                    text: 'Pagos',
                },
            ],
            resource: 'PortalClient',
            action: 'read',
        },
    },
    {
        path: '/monthly-attachments',
        name: 'monthly-attachments',
        component: () =>
            import(
                '@/views/pages/mensualidades-adjunto/MensualidadesAdjunto.vue'
            ),
        meta: {
            pageTitle: 'Mensualidades con Adjunto',
            breadcrumb: [
                {
                    text: 'Mensualidades con Adjunto',
                },
            ],
            resource: 'PortalClient',
            action: 'read',
        },
    },
    {
        path: '/forgot-password/:email?',
        name: 'auth-forgot-password',
        component: () =>
            import('@/views/pages/authentication/ForgotPassword.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
]
